const INITIAL_STATE = {
  signedLogbook: false,
  hseQualification: false,
  renewalQualification: '',
  vqUnitsConforming: false,
  competentRenewalTestQualification: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'GET_QUALIFICATIONS_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'GET_QUALIFICATIONS_VALUES':
      return {
        ...state,
        ...payload,
      };
    case 'RESET_QUALIFICATIONS_DATA':
      return {
        renewalQualification: false,
        hseQualification: false,
      };
    default:
  }
  return state;
};
